"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Applications = exports.ApplicationID = void 0;
var ApplicationID;
(function (ApplicationID) {
    ApplicationID["LE_PSI_SPIRC"] = "le_psi_spirc";
    ApplicationID["LE_PSI_PORC"] = "le_psi_porc";
    ApplicationID["LF_MIA_CH"] = "lf_mia_ch";
    ApplicationID["LE_PS_COPILOT"] = "le_ps_copilot";
    ApplicationID["JRC_AI_HUB"] = "jrc_ai_hub";
    ApplicationID["LINDE_GALLERY"] = "linde_gallery";
    ApplicationID["TICKETING"] = "ticketing";
})(ApplicationID = exports.ApplicationID || (exports.ApplicationID = {}));
const applicationDefinitions = [
    {
        id: ApplicationID.LF_MIA_CH,
        name: "LeaseForce Mia App",
        dataDeletion: { enabled: true },
        linearConnection: {
            teamId: "3518568c-e7dd-44fc-bcda-9d88cd16f14c",
            triageStateId: "809086b2-3a84-4bce-aed8-dc8c699a601f",
            projectId: "f2f63f95-b069-4e25-a472-9c4e13f80a40",
        },
        internalPortal: {
            allowedEmails: [],
            allowedTenantIds: [],
        },
    },
    {
        id: ApplicationID.TICKETING,
        name: "Ticketing",
        linearConnection: {
            teamId: "f2555510-4d5a-4c4a-baaf-6bc4f9169d53",
            triageStateId: "809086b2-3a84-4bce-aed8-dc8c699a601f",
            projectId: "b6be118c-cbe8-4bff-a8e5-c53469749384",
        },
        internalPortal: {
            allowedEmails: [],
            allowedTenantIds: [],
        },
    },
    {
        id: ApplicationID.LE_PSI_SPIRC,
        name: "LE PSI SPIRC",
        linearConnection: {
            teamId: "f2555510-4d5a-4c4a-baaf-6bc4f9169d53",
            triageStateId: "809086b2-3a84-4bce-aed8-dc8c699a601f",
            projectId: "c63726a8-48c5-4cfc-80ea-42b93e774b22",
        },
        internalPortal: {
            allowedEmails: [],
            allowedTenantIds: [],
        },
    },
    {
        id: ApplicationID.LE_PSI_PORC,
        name: "LE PSI PORC",
        linearConnection: {
            teamId: "f2555510-4d5a-4c4a-baaf-6bc4f9169d53",
            triageStateId: "809086b2-3a84-4bce-aed8-dc8c699a601f",
            projectId: "af529491-ee5f-4c49-b8fe-163908a4025d",
        },
        internalPortal: {
            allowedEmails: [],
            allowedTenantIds: [],
        },
    },
    {
        id: ApplicationID.LE_PS_COPILOT,
        name: "PLANTSERV Co-Pilot",
        linearConnection: {
            teamId: "f2555510-4d5a-4c4a-baaf-6bc4f9169d53",
            triageStateId: "809086b2-3a84-4bce-aed8-dc8c699a601f",
            projectId: "c1ab2d89-34b1-4d10-b93e-6eaac5fe8174",
        },
        internalPortal: {
            allowedEmails: [],
            allowedTenantIds: [],
        },
    },
    {
        id: ApplicationID.JRC_AI_HUB,
        name: "JRC AI Hub",
        linearConnection: {
            teamId: "f2555510-4d5a-4c4a-baaf-6bc4f9169d53",
            triageStateId: "809086b2-3a84-4bce-aed8-dc8c699a601f",
            projectId: "f2b6af43-65be-4542-9fb9-090cc30e1d5d",
        },
        internalPortal: {
            allowedEmails: [],
            allowedTenantIds: [],
        },
    },
    {
        id: ApplicationID.LINDE_GALLERY,
        name: "Linde Gallery",
        refPrefix: "linde.gallery",
        linearConnection: {
            teamId: "3518568c-e7dd-44fc-bcda-9d88cd16f14c",
            triageStateId: "809086b2-3a84-4bce-aed8-dc8c699a601f",
            projectId: "ce24fb2e-e1ec-4080-af69-81e4b9e4a0ab",
        },
        internalPortal: {
            allowedEmails: [
                "ferdinand.duschka@linde-le.com",
                "sebastian.buettner@linde-le.com",
                "christian.kaiser@linde-le.com",
                "andrej.ruschel@linde-le.com",
            ],
            allowedTenantIds: [],
        },
        notifyEmails: [
            {
                to: "linde.gallery@linde.com",
                from: "ferdinand.duschka@copetence.de",
            },
        ],
        ticketCategories: [
            {
                id: "SEARCH_ISSUES",
                name: "Search Issues",
                description: "Issue with the search, filter or sort functionality.",
            },
            {
                id: "UPLOAD_ISSUES",
                name: "Upload Issues",
                description: "Issue with the upload functionality.",
            },
            {
                id: "TAGGING_ISSUES",
                name: "Tagging Issues",
                description: "Issue with the tagging functionality.",
            },
            {
                id: "WRONG_METADATA",
                name: "Wrong or misleading metadata",
                description: "Report a file which contains false information or misleading metadata.",
            },
            {
                id: "FALSE_POSITIVE_AI_FLAG",
                name: "False positive AI flag",
                description: "Report a file which is falsely flagged by the AI as uncompliant.",
            },
            {
                id: "OTHER_ISSUES",
                name: "Other Issues",
                description: "Other issues not covered by the other categories.",
            },
            {
                id: "FEATURE_REQUEST",
                name: "Feature Request & Improvements",
                description: "Request for a new feature or enhancement to the application.",
            },
        ],
    },
];
/**
 * Each application's ref prefix defaults to its id. To use a different prefix,
 * set `refPrefix` explicitly on the definition above and it will take priority.
 */
exports.Applications = applicationDefinitions.map((app) => ({
    refPrefix: app.id,
    ...app,
}));
